(() => {
  if (window.RCStarfieldReady) return;
  window.RCStarfieldReady = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const appearance = matchMedia('(prefers-color-scheme: light)');
  let manualPause = false;
  try { manualPause = localStorage.getItem('rc-atmosphere-paused') === 'true'; } catch (_) { }
  const paused = () => motion.matches || manualPause;
  const updateButtons = () => {
    document.documentElement.classList.toggle('rc-motion-paused', paused());
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.textContent = paused() ? button.dataset.resume : button.dataset.pause;
      button.setAttribute('aria-pressed', String(paused()));
    });
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-motion-toggle]')) return;
    manualPause = !manualPause;
    try { localStorage.setItem('rc-atmosphere-paused', String(manualPause)); } catch (_) { }
    updateButtons();
  });
  motion.addEventListener('change', updateButtons);
  function init(canvas) {
    if (canvas.dataset.initialized) return;
    const ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) return;
    canvas.dataset.initialized = 'true';
    const gate = canvas.closest('[data-door-stage]');
    let seed = 1291, stars = [], auras = [], last = -100, tick = 0, metal;
    const random = () => { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; };
    const grain = document.createElement('canvas'); grain.width = grain.height = 64;
    const grainCtx = grain.getContext('2d');
    const glitter = document.createElement('canvas'); glitter.width = glitter.height = 128;
    const glitterCtx = glitter.getContext('2d');
    if (glitterCtx) {
      const texture = glitterCtx.createImageData(128, 128);
      for (let i = 0; i < texture.data.length; i += 4) {
        const value = random() > .48 ? 255 : 12;
        texture.data[i] = texture.data[i + 1] = texture.data[i + 2] = value;
        texture.data[i + 3] = Math.round(15 + random() * 75);
      }
      glitterCtx.putImageData(texture, 0, 0);
    }
    function resize() {
      canvas.width = Math.round(Math.min(window.innerWidth * .7, 960));
      canvas.height = Math.round(canvas.width * window.innerHeight / window.innerWidth);
      seed = 1291;
      stars = Array.from({ length: Math.min(650, Math.round(canvas.width * canvas.height / 650)) }, () => ({ x: random(), y: random(), r: .55 + random() * 1.1, phase: random() * 6.28, rate: 1.2 + random() * 1.3, brightness: .45 + random() * .5 }));
      auras = Array.from({ length: Math.max(6, Math.min(16, Math.round(canvas.width * canvas.height / 32000))) }, () => ({ x: random(), y: random(), r: 5 + random() * 12, phase: random(), rate: .055 + random() * .045 }));
      metal = ctx.createLinearGradient(0, 0, canvas.width, canvas.height * .65);
      [[0, '#b7b9bd'], [.22, '#e1e2e4'], [.48, '#bdc0c4'], [.73, '#e4e5e7'], [1, '#b1b4ba']].forEach(([stop, color]) => metal.addColorStop(stop, color));
      draw(0);
    }
    function draw(seconds) {
      const silver = appearance.matches && !gate;
      ctx.globalAlpha = 1;
      ctx.fillStyle = silver ? metal : '#020506'; ctx.fillRect(0, 0, canvas.width, canvas.height);
      if (silver && glitterCtx) {
        ctx.globalAlpha = .28;
        ctx.fillStyle = ctx.createPattern(glitter, 'repeat'); ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.globalAlpha = 1;
      }
      auras.forEach(aura => {
        const cycle = paused() ? .45 : (seconds * aura.rate + aura.phase) % 1;
        const light = Math.pow(Math.sin(cycle * Math.PI), 1.5);
        const radius = aura.r * (.6 + cycle * 1.8);
        const x = aura.x * canvas.width, y = aura.y * canvas.height;
        const glow = ctx.createRadialGradient(x, y, 0, x, y, radius);
        glow.addColorStop(0, silver ? 'rgba(255,255,255,.95)' : 'rgba(214,226,219,.34)');
        glow.addColorStop(.2, silver ? 'rgba(255,255,255,.48)' : 'rgba(159,178,199,.12)');
        glow.addColorStop(1, silver ? 'rgba(255,255,255,0)' : 'rgba(90,110,150,0)');
        ctx.globalAlpha = light;
        ctx.fillStyle = glow; ctx.fillRect(x - radius, y - radius, radius * 2, radius * 2);
      });
      stars.forEach(star => {
        const blink = paused() ? .8 : .22 + .78 * Math.pow(.5 + .5 * Math.sin(seconds * star.rate + star.phase), .7);
        ctx.globalAlpha = star.brightness * blink;
        ctx.fillStyle = silver ? '#16181c' : '#eef0da';
        ctx.fillRect(Math.round(star.x * canvas.width), Math.round(star.y * canvas.height), star.r, star.r);
        if (star.r > 1.38) { ctx.globalAlpha *= .24; ctx.fillRect(star.x * canvas.width - 2, star.y * canvas.height, 5, 1); }
        if (silver) {
          ctx.globalAlpha = Math.pow(blink, 4) * star.brightness;
          ctx.fillStyle = '#ffffff';
          const x = Math.round(star.x * canvas.width) + 1, y = Math.round(star.y * canvas.height) - 1;
          ctx.fillRect(x, y, star.r + .6, 1);
          if (star.r > 1.38) ctx.fillRect(x + 1, y - 1, 1, 3);
        }
      });
      ctx.globalAlpha = 1;
      if (grainCtx && !paused() && tick++ % 4 === 0) {
        const data = grainCtx.createImageData(64, 64);
        for (let i = 0; i < data.data.length; i += 4) { const value = random() > .5 ? 255 : 0; data.data[i] = data.data[i + 1] = data.data[i + 2] = value; data.data[i + 3] = Math.round(random() * 28); }
        grainCtx.putImageData(data, 0, 0);
      }
      if (grainCtx) { ctx.globalAlpha = .3; ctx.fillStyle = ctx.createPattern(grain, 'repeat'); ctx.fillRect(0, 0, canvas.width, canvas.height); ctx.globalAlpha = 1; }
    }
    let stopped = false, raf;
    function frame(now) {
      if (stopped || !canvas.isConnected) return;
      raf = requestAnimationFrame(frame);
      if (document.hidden || appearance.matches || paused() || now - last < 1000 / 20 || (gate ? gate.hidden : document.documentElement.classList.contains('rc-door-active'))) return;
      last = now; draw(now / 1000);
    }
    resize(); raf = requestAnimationFrame(frame);
    const recolor = () => draw(Math.max(0, last) / 1000);
    appearance.addEventListener('change', recolor);
    window.addEventListener('resize', resize, { passive: true });
    canvas.addEventListener('rc-starfield:destroy', () => { stopped = true; cancelAnimationFrame(raf); appearance.removeEventListener('change', recolor); window.removeEventListener('resize', resize); delete canvas.dataset.initialized; }, { once: true });
  }
  function scan(scope) {
    scope.querySelectorAll('[data-rc-starfield]').forEach(init);
    updateButtons();
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-rc-starfield]').forEach(canvas => canvas.dispatchEvent(new Event('rc-starfield:destroy'))));
})();
